"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * An object representation of shopper data extracted from the info_idp cookie if present.
 * Note: Additional properties may be available
 *
 * @typedef {Object} InitialShopperData
 * @property {string} shopperid The Shopper ID
 * @property {string} auth The auth-type that the user signed in with
 * @property {string} username The username of the current user
 * @property {string} info The raw info_idp value
 * @property {string} firstname The user's first name
 * @property {string} lastname The user's last name
 */

/**
 * An object representation of the full shopper data, merging the latest data from the
 * info_idp cookie with the results of calling GUI to get the latest information, if necessary
 * Note: Additional properties may be available
 *
 * @typedef {InitialShopperData} FullShopperData
 * @property {Array} tms The TMS values
 * @property {string} fullname The user's full name
 */

/**
 * Callback function to get notified about shopper data updates
 * @callback ShopperUpdate
 * @param {Error} error Any error that occurred
 * @param {FullShopperData} data The full shopper data after update
 */

/**
 * Shallow copies the properties of the source into the target
 * @param {Object} target Where the properties should be copied
 * @param {Object} source Where the properties come from
 */
function copyInto(target, source) {
  Object.keys(source).reduce(function (acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
}
/**
 * Class to provide synchronous access to some shopperData, with optional updates via callback with the full data.
 *
 * @class SyncAccess
 */


var SyncAccess =
/*#__PURE__*/
function () {
  function SyncAccess() {
    _classCallCheck(this, SyncAccess);

    this.data = this.data.bind(this);
    this._cbs = [];
    this._data = null;
    this._updated = false;
  }
  /**
   * Interface method, should be implemented by inheriting class.
   * Return the defaults to be used for `this._data`.
   *
   * @returns {Object} data.
   * @private
   */


  _createClass(SyncAccess, [{
    key: "transform",

    /**
     * Interface method, should be implemented by inheriting class.
     * Transform the data after it has been fetched.
     *
     * @param {Object} data Data to be transformed.
     * @returns {Object} transformed data.
     * @private
     */
    value: function transform(data) {
      return data;
    }
    /**
     * Interface method, should be implemented by inheriting class.
     * Fetch data from API and callback.
     *
     * @param {function} done completion callback.
     * @private
     */

  }, {
    key: "fetch",
    value: function fetch() {
      var done = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      done();
    }
    /**
     * Fetch and update the shopper data. Notify any callback listeners of the update
     *
     * @private
     */

  }, {
    key: "updateWithShopperData",
    value: function updateWithShopperData() {
      var _this = this;

      this.fetch(function (error) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (error) return;

        if (_this._data) {
          // Copy the data over into the existing object so that it updates the existing object we
          // already returned with the new data.
          copyInto(_this._data, _this.transform(data));
          copyInto(_this._data, data);
          _this._updated = true;
          var cbs = _this._cbs;
          _this._cbs = [];

          for (var i = 0; i < cbs.length; i++) {
            cbs[i](null, _this._data);
          }
        }
      });
    }
    /**
     * Provides synchronous access to shopperData
     * @param {ShopperUpdate} [onUpdate] Callback mechanism to receive updates once full shopperData is loaded.
     * If shopperData was already loaded, this won't be called.
     * @returns {InitialShopperData|FullShopperData} The latest shopperData available, may be out of date based on cookie values.
     * If shopperData was already loaded, it will be the full & correct data
     * @public
     */

  }, {
    key: "data",
    value: function data(onUpdate) {
      if (!this._updated && onUpdate) {
        this._cbs.push(onUpdate);
      }

      if (this._data) {
        return this._data;
      }

      this._data = this.transform(this.defaults); // Kick off data updates

      this.updateWithShopperData();
      return this._data;
    }
  }, {
    key: "defaults",
    get: function get() {
      return {};
    }
  }]);

  return SyncAccess;
}();

exports["default"] = SyncAccess;